// extracted by mini-css-extract-plugin
export default {"container":"Container_container__5ig0t","min-height":"Container_min-height__hMk9x","start":"Container_start__vr7Hr","column":"Container_column__Upcks"};